import { render, staticRenderFns } from "./point_style.vue?vue&type=template&id=95559e22&scoped=true&"
import script from "./point_style.vue?vue&type=script&lang=js&"
export * from "./point_style.vue?vue&type=script&lang=js&"
import style1 from "./point_style.vue?vue&type=style&index=1&id=95559e22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95559e22",
  null
  
)

export default component.exports